export function getDateSeed(prefix?: string): string {
  return `${prefix ? prefix : ''}${new Date().toISOString()}`;
}
